<script>
	import { brand } from "src/brand";

	const currentYear = new Date().getFullYear();
</script>

<div class="left">
	<div
		class="d-flex flex-column align-items-center justify-content-center w-100"
	>
		<div>
			<img
				src={brand.loginLogo.img}
				alt="logo"
				style={brand.loginLogo.style}
			/>
		</div>
		<div class="copyright">
			<span> Copyright © {currentYear}. All Rights Reserved </span>
		</div>
	</div>
</div>
